import { render, staticRenderFns } from "./DatetimeField.vue?vue&type=template&id=4b87e4fc"
import script from "./DatetimeField.vue?vue&type=script&lang=js"
export * from "./DatetimeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports